import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { ChangeEvent, useEffect, useLayoutEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthStore } from "../../../store/auth.store";
import { LoadingPage } from "../../../utils/components/LoadingPage";

export function ResetPassword() {
    const { setUserBrowserData, accessToken, logout, refresh, sendResetEmail } =
        useAuthStore();
    const navigate = useNavigate();

    // Проверка авторизации и редирект на главную страницу, если авторизован
    const [loadingIsAuth, setLoadingIsAuth] = useState(false);
    useLayoutEffect(() => {
        (async () => {
            try {
                setLoadingIsAuth(true);
                if (accessToken) {
                    const isAuthed = await refresh();
                    console.log(isAuthed);
                    if (isAuthed) location.href = "/admin";
                }
            } catch (error) {
                logout();
            } finally {
                setLoadingIsAuth(false);
            }
        })();
    }, []);

    useEffect(() => {
        setUserBrowserData(navigator.userAgent);
    }, []);

    const [error, setError] = useState("");
    const [email, setEmail] = useState("");
    const handleChangeEmail = (
        data: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setEmail(data.target.value.trim());
        const correct = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
            data.target.value.trim()
        );
        if (!correct) setError("Некорректный email");
        else setError("");
    };

    const handleSendEmail = async () => {
        try {
            const correct = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
            if (!correct) return setError("Некорректный email");
            else setError("");
            const hash = await sendResetEmail(email);
            if (hash) navigate("/resetpassword/code?hash=" + hash);
        } catch (error) {}
    };

    if (loadingIsAuth) return <LoadingPage />;

    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Paper
                sx={{
                    padding: "40px",
                    margin: "0 40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "left",
                    gap: "8px",
                }}
            >
                <h1>Восстановление пароля</h1>
                <Typography>
                    Введите адрес электронной почты, на который зарегистрирован
                    ван аккаунт
                </Typography>
                <TextField
                    name="email"
                    type="email"
                    placeholder="admin@example.com"
                    error={error != ""}
                    helperText={error}
                    onChange={handleChangeEmail}
                    value={email}
                />
                <Button variant="contained" onClick={handleSendEmail}>
                    Восстановить
                </Button>
                <Typography variant="caption" color="text.secondary">
                    Если вы попали на эту страницу случайно, то вы можете
                    вернуться на <Link to="/">главную страницу</Link>
                </Typography>
            </Paper>
        </Box>
    );
}
